import React from 'react'
import styled from '@emotion/styled/macro'
import { useTranslation } from 'react-i18next'
import Button from '../Forms/Button'
import Warning from '../../assets/warning.svg'
import write from '../../assets/Write.svg'
import useThemeContext from 'hooks/useThemeContext'

import mq from 'mediaQuery'

const ConfirmContainer = styled('div')`
  // &:before {
  //   display: none;
  //   background: url(${write});
  //   content: '';
  //   height: 43px;
  //   width: 42px;
  //   float: right;
  //   ${mq.large`
  //     display: block;
  //     flex-direction: row;
  //   `}
  // }
`
const Content = styled('div')`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`

const Title = styled('h3')`
  font-size: 16px;
  font-weight: 700;
  ${mq.small`
    font-size: 22px;
  `}
`

const SubTitle = styled('p')`
  margin: 0;
  margin-bottom: 1em;
  font-size: 12px;
  ${mq.small`
    font-size: 14px;
  `}
`

const Values = styled('ul')`
  list-style-type: none;
  padding: 4px 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const Value = styled('li')`
  font-size: 12px;
  font-weight: bold;
  font-family: Overpass Mono;
  display: flex;
  justify-content: space-between;
  color: ${({ old }) => (old ? 'grey' : 'black')};
  margin-bottom: 10px;

  ${mq.large`
    justify-content: flex-start;
  `}

  span:first-child {
    width: 75px;
  }
`

const Buttons = styled('div')`
  height: 100%;
  margin-top: 1em;
  display: flex;
  justify-content: flex-end;
`
const Action = styled(Button)``

const Cancel = styled(Button)`
  width: 120px;
  padding: 10px 20px;
  margin-right: 5px;

  border-radius: 0;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 160%;
  letter-spacing: 0.15px;
  border: 0.5px solid #e7303c;
  background: ${({ isDark }) => (isDark ? '#E7303C' : '#fff')};
  color: ${({ isDark }) => (isDark ? '#fff' : '#e7303c')};

  &:visited {
    color: inherit;
  }
  &:hover {
    cursor: pointer;
    border: none;
    background: ${({ isDark }) => (isDark ? '#E7303C' : '#fff')};
    box-shadow: none;
    border-radius: 0;
    border: 0.5px solid #e7303c;
  }

  ${mq.medium`
    min-width: 210px;
    padding: 20px 50px
  `}
`

const Save = styled(Cancel)`
  background: #f1bc11;
  color: #000;
  border: none;
  &:hover {
    background: #f1bc11;
    border: none;
  }
`

const TxtVal = styled('span')`
  max-width: 210px;
  word-wrap: break-word;

  ${mq.medium`
    min-width: 100%;
  `}
`

const Confirm = ({
  mutation,
  cancel,
  disabled,
  className,
  value,
  extraDataComponent,
  newValue,
  explanation
}) => {
  const { t } = useTranslation()
  const { isDark } = useThemeContext()
  return (
    <ConfirmContainer className={className}>
      <div
        style={{ display: 'flex', alignItems: 'center', margin: '20px 0 40px' }}
      >
        <img src={Warning} alt="Warning" />
        <Title style={{ marginLeft: 10 }}>
          {t('singleName.confirm.title')}
        </Title>
      </div>
      <SubTitle>{t('singleName.confirm.subTitle')}</SubTitle>
      <Content>
        {explanation ? <p>{explanation}</p> : ''}
        {extraDataComponent ? <>{extraDataComponent}</> : ''}
        {value || newValue ? (
          <Values>
            <Value old={true} style={{ color: '#4CAF50' }}>
              <span>CURRENT</span>
              <TxtVal>{value}</TxtVal>
            </Value>
            <Value style={{ color: '#5384FE' }}>
              <span>NEW</span>
              <TxtVal>{newValue}</TxtVal>
            </Value>
          </Values>
        ) : (
          ''
        )}
        <Buttons>
          <Cancel type="hollow" isDark={isDark} onClick={cancel}>
            {t('singleName.confirm.button.cancel')}
          </Cancel>
          {disabled ? (
            <Save type="disabled" data-testid="send-transaction">
              {t('singleName.confirm.button.confirm')}
            </Save>
          ) : (
            <Save
              data-testid="send-transaction"
              onClick={() => {
                mutation()
                cancel()
              }}
            >
              {t('singleName.confirm.button.confirm')}
            </Save>
          )}
        </Buttons>
      </Content>
    </ConfirmContainer>
  )
}

export default Confirm
